var $form = document.querySelector('.js-tax-calculator-form');
var $formInputs = document.querySelectorAll('.js-input-number');

var $loadingIcon = document.querySelector('.js-loading');

var $formStep1 = document.querySelector('.js-form-step-1');
var $formStep2 = document.querySelector('.js-form-step-2');

var $formStep1Fields = $formStep1.querySelectorAll('input');

var $btnSubmit = document.querySelector('.js-submit-button');
var $btnRestart = document.querySelector('.js-btn-restart');

var $toastSuccess = document.querySelector('.js-alert-toast');
var $resultPreview = document.querySelector('.js-result-preview');

var $selectFilterType = document.querySelector('.js-filter-type');
var $selectFilterInstallments = document.querySelector('.js-filter-installments');

var $resultTemplate = document.querySelector('.js-result-table-template');
var $resultOnlineWrapper = document.querySelector('.js-online-result');
var $resultPhysicalWrapper = document.querySelector('.js-physical-result');
var $resultPhysicalDebitWrapper = document.querySelector('.js-physical-debit-result');

var data = {};

data.activeFilter = {
    type: 'online',
    installment: 0
}

data.utils = {};
data.online = {};
data.physical = {};
data.physical_debit = {};

data.utils.onlineReceipt = [];
data.utils.onlineTaxes = []

data.utils.physicalReceipt = [];
data.utils.physicalTaxes = [];

data.utils.physicalDebitReceipt = [];
data.utils.physicalDebitTaxes = [];

// Subscribe form
var $formSubscribe = document.querySelector('.js-form-subscribe');

function handleStart() {
    // Get all taxes from spreedsheet
    getDataFromSheet();

    // handle simple num validation
    $formInputs.forEach(item => item.addEventListener('input', (el) => {
        el.target.value= el.target.value.replace(/[^0-9.,]/g,'')
    }));

    // Check form steps
    const validate = new Bouncer('.js-tax-calculator-form', {
        disableSubmit: true,
        messages: {
            missingValue: {
                text: validationErrors.required,
                number: validationErrors.required,
                email: validationErrors.required
            },
            patternMismatch: {
                email: validationErrors.email,
            },
        },
    });

    $btnRestart.addEventListener('click', (e) => {
        e.preventDefault();
        handleStep(2,1);

        $resultOnlineWrapper.innerHTML = '';
        $resultPhysicalWrapper.innerHTML = '';
        $resultPhysicalDebitWrapper.innerHTML = '';

        $form.reset();


        data.activeFilter = {
            type: 'online',
            installment: 0
        }

        $selectFilterType.value = data.activeFilter.type;
        $selectFilterType.dispatchEvent(new Event('change'));
    })

    // Steps
    handleStep1(validate);
}

function switchFilters(type) {
    const formType = type == 'online' ? data.utils.onlineReceipt : data.utils.physicalReceipt;
    $selectFilterInstallments.innerHTML = '';

    data.activeFilter.installment = formType[0];

    formType.forEach(item => {
        var option = document.createElement('option');
        option.value = item;
        option.innerText = item == 0 ? at_now : (item > 1 ? item + ' ' + days : item + ' ' + day);
        $selectFilterInstallments.append(option);
    });

    $selectFilterInstallments.addEventListener('change', (option) => {
        var selectedInstallment = option.target.value;
        data.activeFilter.installment = selectedInstallment;
        showResultsByFilter();
    });
}

// Filter table by type: Online or Physical
function filterByType() {
    $selectFilterType.addEventListener('change', (el) => {
        const selectedValue = el.target.value;
        data.activeFilter.type = selectedValue;

        const $currentTable = document.querySelector('.js-type-filtered:not(.hide)');
        const $hiddenTable = document.querySelector('.js-type-filtered.js-form-step-' + selectedValue);

        handleStep($currentTable, $hiddenTable);
        switchFilters(selectedValue);
        showResultsByFilter();
    })
}

function showResultsByFilter() {
    const $tables = document.querySelectorAll('.js-'+data.activeFilter.type+'-result .js-result-table-wrapper');
    const $debitTable = document.querySelector('.js-physical-debit-result .js-result-table-wrapper');

    $tables.forEach(table => {
        if(table.dataset.receipt != data.activeFilter.installment) {
            table.classList.add('hide');
        } else {
            table.classList.remove('hide');
        }
    });

    if(data.activeFilter.type == 'physical' &&  $debitTable) {
        $debitTable.classList.remove('hide');
    }
}

// Handle steps
function handleStep(stepFrom, stepTo) {
    if(typeof stepFrom == 'object') {
        var $getFrom = stepFrom;
        var $goTo = stepTo;
    } else {
        var $getFrom = document.querySelector('.js-form-step-' + stepFrom );
        var $goTo = document.querySelector('.js-form-step-' + stepTo);
    }

    $getFrom.classList.add('slide-up-out');
    $goTo.classList.add('slide-up');

    $getFrom.ariaHidden = true;
    $goTo.ariaHidden = false;

    setTimeout(() => {
        $getFrom.classList.add('hide');
        $goTo.classList.remove('hide');
        $goTo.classList.remove('slide-up-out');
    },100)
}

// Handle step actions
function handleStep1(validate) {
    $btnSubmit.addEventListener('click', function(el) {
        const nextStep = el.target.dataset.next;
        const currentStep = parseInt(nextStep) - 1;
        const isValidStep1 = validate.validateAll($formStep1);

        if(isValidStep1.length == 0) {
            fillDataObjectFromNode($formStep1Fields, data);
            isLoading(true);

            setTimeout(function(){
                handleResultsPreview();
                handleStep(currentStep, nextStep);
            }, 2300);
        }
    });
}

// Format string values and replace pontuations
function _fm(value) {
    var valueFormatted = String(value).replaceAll('.', '').replaceAll(',', '.');
    return parseFloat(valueFormatted);
}

function _fm_currency(num) {
    var formatOptions = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        maximumFractionDigits: 2
    });

    return formatOptions.format(num);
}

// Format string values and replace pontuations
function getValueFromPercent(percentage, value) {
    if(typeof percentage == 'number' && typeof value == 'number') {
        const difference = (percentage / 100) * value;
        const total = value - difference;

        return total.toFixed(2);
    }

    throw new Error('Params have to be Number');
}

function generateDataValues(dataReceipt, dataTaxes, dataType) {
    data.utils[dataReceipt] = data.sheet.filter(el => el[3] == dataType).map(receipt => receipt[1]).reduce((prev,current) => {
        if(prev.indexOf(current)<0) prev.push(current); return prev; }
    ,[]);

    data.utils[dataReceipt].forEach((item, key) => {
        data.utils[dataTaxes].push([]);
        data.sheet.filter(el => {
            if(el[3] == dataType && el[1] == item) {
                data.utils[dataTaxes][key].push({
                    installment: Number(el[0]),
                    percent: Number(el[2]),
                    tax: el[4] ? Number(el[4]) : 0
                })
            }
        })
    });

    data.activeFilter.installment = data.utils.onlineReceipt[0];
}

function handleCalculate() {

    // Online
    data.utils.onlineReceipt.forEach((item, key) => {
        data.online[item] = data.utils.onlineTaxes[key].map((el, mapKey) => {
            const itemsAmount = data.utils.onlineTaxes[key].length - 1;
            const hasFromOf = mapKey == itemsAmount && el.installment != 0 && itemsAmount < 6;

            var percentCalculated = getValueFromPercent(Number(el.percent), _fm(data.money_value));
            var totalCalculatedWithTax = el.tax > 0 ? Number(percentCalculated) + el.tax : percentCalculated;

            const result = {
                id: 'online-' + item + '-' + el.installment,
                days: hasFromOf ? from_of+ ' ' +el.installment : el.installment,
                percent: el.percent,
                total: _fm_currency(totalCalculatedWithTax)
            }

            var $nodeElement = document.querySelector('#' + result.id);
            if($nodeElement) $nodeElement.innerHTML = result.total;

            return result;
        });
    });

    // Physical
    data.utils.physicalReceipt.forEach((item, key) => {
        data.physical[item] = data.utils.physicalTaxes[key].map((el, mapKey) => {
            const itemsAmount = data.utils.physicalTaxes[key].length - 1;
            const hasFromOf = mapKey == itemsAmount && el.installment != 0 && itemsAmount < 6;

            var percentCalculated = getValueFromPercent(Number(el.percent), _fm(data.money_value));
            const result = {
                id: 'physical-' + item + '-' + el.installment,
                days: hasFromOf ? from_of+ ' ' +el.installment : el.installment,
                percent: el.percent,
                total: _fm_currency(percentCalculated)
            }

            var $nodeElement = document.querySelector('#' + result.id);
            if($nodeElement) $nodeElement.innerHTML = result.total;

            return result;
        });
    });

    // Physical Debit
    data.utils.physicalDebitReceipt.forEach((item, key) => {
        data.physical_debit[item] = data.utils.physicalDebitTaxes[key].map(el => {
            var percentCalculated = getValueFromPercent(Number(el.percent), _fm(data.money_value));
            const result = {
                id: 'physical-debit-' + item + '-' + el.installment,
                days: el.installment,
                percent: el.percent,
                total: _fm_currency(percentCalculated)
            }

            var $nodeElement = document.querySelector('#' + result.id);
            if($nodeElement) $nodeElement.innerHTML = result.total;

            return result;
        });
    });

    generateResultPreviews(data.utils.physicalReceipt, data.physical, $resultPhysicalWrapper);
    generateResultPreviews(data.utils.onlineReceipt, data.online, $resultOnlineWrapper);

    if(Object.keys(data.physical_debit).length > 0) {
        generateResultPreviews(data.utils.physicalDebitReceipt, data.physical_debit, $resultPhysicalDebitWrapper);
        $resultPhysicalDebitWrapper.querySelector('th').innerText = debit;

    }

    showResultsByFilter();
}

async function getDataFromSheet() {
    const response = await fetch(sheetDataUrl).then(res => res.text());

    data.sheet = response.split(/\n|\r\n/);
    data.sheet = data.sheet.slice(1).map(item => item.split(','));

    generateDataValues('onlineReceipt', 'onlineTaxes', 'online');
    generateDataValues('physicalReceipt', 'physicalTaxes', 'physical');
    generateDataValues('physicalDebitReceipt', 'physicalDebitTaxes', 'physical_debit');

    switchFilters('online');

}

function generateResultPreviews(utilsReceipt, dataType, outputWrapper) {
    utilsReceipt.forEach((receipt) => {
        let $clonedTemplate = $resultTemplate.content.cloneNode(true);
        let $clonedTemplateWrapper = $clonedTemplate.querySelector('.js-result-table-wrapper');

        $clonedTemplateWrapper.dataset.receipt = receipt;

        dataType[receipt].forEach(item => {
            var tableRow = document.createElement('tr');
            var getInstallments;

            switch(item.days) {
                case 0:
                    getInstallments = oncash;
                    break;
                default:
                    getInstallments = item.days + 'x';
                    break;
            };

            tableRow.innerHTML = '<td>'+ getInstallments +'</td><td>'+ item.percent +'%</td><td><strong>'+ item.total +'</strong></td>';

            $clonedTemplateWrapper.querySelector('tbody').append(tableRow);
        })

        outputWrapper.append($clonedTemplateWrapper);
    });
}

// Preview results data
function handleResultsPreview() {
    isLoading(false);
    handleCalculate();
    filterByType();
}

// Get all input filled to show an preview
function fillDataObjectFromNode($nodeElement, data) {
    $nodeElement.forEach(field => {
        data[field.id] = field.value == "" ? "0" : field.value;
    });
}

// Replace data from specific node element
function handleReplaceDataField($nodeElement, input, output) {
    $nodeElement.querySelector('[data-field="'+input+'"]').innerHTML = output;
}

// Handle subscription form to store user data on Hubspot
async function handleSubscribeForm() {
    if( !$.cookie('tool_' + landing + '_subscribe_modal_gate') || !HUBSPOT_FORM_EMBED.hasFinished()) {
        toolsSubscribe();

        $('#modal-subscribe').modal('show');
        amplitude_log_event('tools_' + landing + '_modal', {
            'state': 'opened'
        });

        document.addEventListener('onToolsSubscribe', function (params) {
            $('#modal-subscribe').modal('hide');
            amplitude_log_event('tools_' + landing + '_modal', {
                'state': 'closed'
            });

            $.cookie('tool_' + landing + '_subscribe_modal_gate', true, { expires: 30, path: '/' });

            amplitude_log_event('tools_subscribed', {
                'tool_name': landing
            });
        })

    }
}

// Toggle loading icon and label from submit button
function isLoading(state) {
    if(state) {
        $loadingIcon.classList.remove('hide');
        return;
    }

    $loadingIcon.classList.add('hide');
}

function checkIfReady() {
    if (typeof Bouncer != 'undefined' && typeof toolsSubscribe != 'undefined' && typeof jQuery !== 'undefined') {
        handleStart();
    } else {
        setTimeout(checkIfReady, 1000);
    }
}

checkIfReady();